export const uri = {
    index: '/',
    about: '/about-catalina-island/',
    featuredproperty: '/featured-property/',
    contact: '/contact-us/',
    home: '/home/',
    properties: '/properties/',
    aboutmj: '/about-mj-leonhardi/',
    calculator:'/financial-calculator/'
}